import React, { ReactNode } from 'react';
import clsx from 'clsx';
import './NoResultFound.less';
import { ReactComponent as NoResultsIcon } from 'assets/images/no_results.svg';

interface Props {
  icon?: React.FC<React.SVGProps<SVGSVGElement>>;
  title: string | ReactNode;
  description?: string | ReactNode;
  action?: ReactNode;
  className?: string;
}

export default function NoResultFound({
  icon: Icon = NoResultsIcon,
  title,
  description,
  action,
  className,
}: Props) {
  return (
    <div className={clsx('no-result-found', className)}>
      <Icon />

      <p className="no-result-found__title">{title}</p>

      {description && (
        <p className="no-result-found__description">{description}</p>
      )}

      {action && <div className="no-result-found__action">{action}</div>}
    </div>
  );
}
